 /*=========================================================================================
  File Name: state.js
  Description: Categories Actions
  ----------------------------------------------------------------------------------------
  Item Name: Categories State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/categories/queries.js'
import commands from '../../../services/categories/commands.js'
import ErrorHandling from '../../../common/exceptions/ErrorHandling.js'

export default {

    async getCategoriesAction ( { commit, state, rootState }, payload) {

        let token = rootState.auth.auth.token;
        let restaurantId = rootState.auth.auth.restaurantId;
        let error = null;
        try {
            await queries.getCategoriesByRestaurant(restaurantId, token)
                     .then(
                         res => {
                             commit('SET_CATEGORIES_STATE', res); 
                        });
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    },

    async createCategoryAction( { commit, state, rootState }, payload) {

        let token = rootState.auth.auth.token;
        let restaurantId = rootState.auth.auth.restaurantId;
        payload.restaurantId = restaurantId;
        let error = null;
        try {

            let res = await commands.createCategory(payload, token);

            let category = {
                categoryId : res,
                name : payload.name,
                description : payload.description
            }
            commit('ADD_CATEGORY_STATE', category);
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    },

    async updateCategoryAction ( { commit, state, rootState }, payload) {

        let token = rootState.auth.auth.token;
        let restaurantId = rootState.auth.auth.restaurantId;
        let error = null;
        try {
            await commands.updateCategory(payload, payload.categoryId, token);
            commit('UPDATE_CATEGORY_STATE', payload);
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    }

}